import { convertDataToTreeSelect } from '../utils/bvUtil';
import { multiSelectObj } from './certificateService';
import { fetchDataPutReq } from '../apis/apiUtil';
import mdmService from "./MDMService";
export function getRegLibFilterSectionData(docStatusList, selDocStatusList, setSelDocStatusList, regCountryList, selRegCountryList, setSelRegCountryList, mainSubProdList, selMainSubProdList, setSelMainSubProdList, serviceTypeList, selServiceTypeList, setSelServiceTypeList, handleClearAllAppliedFilters) {
    return {
        name: 'reg_lib_filter_panel',
        selectOptionsList: selectOptionsList(selDocStatusList, setSelDocStatusList, (docStatusList || [])),
        treeSelectList: treeSelectList((regCountryList || []), selRegCountryList, setSelRegCountryList, (mainSubProdList || []), selMainSubProdList, setSelMainSubProdList),
        // multiSelectList: [
        //   multiSelectObj('Service Type', selServiceTypeList, setSelServiceTypeList, ServiceTypeJSON),
        // ],
        handleClearAll: handleClearAllAppliedFilters
    };
}
function selectOptionsList(selDocStatusList, setSelDocStatusList, docStatusList) {
    const regLibStatusOptions = docStatusList.map((item) => ({
        label: item === null || item === void 0 ? void 0 : item.strLongDesc,
        value: String(item === null || item === void 0 ? void 0 : item.intId),
    }));
    return [
        {
            selectOptions: {
                data: regLibStatusOptions,
                title: 'Document Status',
                value: selDocStatusList,
                setValue: (val) => setSelDocStatusList(val)
            }
        }
    ];
}
function treeSelectList(regCountryList, selRegCountryList, setSelRegCountryList, mainSubProdList, selMainSubProdList, setSelMainSubProdList) {
    return [
        {
            treeSelect: {
                data: convertDataToTreeSelect(regCountryList, (country) => country.objLuRegion.strLongDesc, (country) => country.objLuRegion.intId, (country) => country.lstLuCountries),
                title: 'Country',
                value: selRegCountryList,
                setParentChildValue: (val) => setSelRegCountryList(val)
            }
        },
        {
            treeSelect: {
                data: convertDataToTreeSelect(mainSubProdList, null, null, (prod) => prod.lstProductTypes),
                title: 'Product',
                value: selMainSubProdList,
                setParentChildValue: (val) => setSelMainSubProdList(val)
            }
        },
    ];
}
export function getRegLibNotiDropdown(regCountryList, selRegCountryList, setSelRegCountryList, mainSubProdList, selMainSubProdList, setSelMainSubProdList, serviceTypeList, selServiceTypeList, setSelServiceTypeList) {
    return {
        name: 'reg_lib_filter_panel',
        treeSelectList: treeSelectList((regCountryList || []), selRegCountryList, setSelRegCountryList, (mainSubProdList || []), selMainSubProdList, setSelMainSubProdList),
        multiSelectList: [
            multiSelectObj('Service Type', selServiceTypeList, setSelServiceTypeList, serviceTypeList),
        ],
    };
}
export function getRegulatoryInfoReact(data) {
    const url = `getRegulatoryInfoReact`;
    return fetchDataPutReq(url, data);
}
export function getCompareVerRegulatoryInfo(data) {
    const url = `getCompareVerRegulatoryInfo`;
    return fetchDataPutReq(url, data);
}
export const updateAppliedSavedFilters = (searchObject) => {
    return new Promise((resolve, reject) => {
        mdmService
            .getClientProfileDetails(searchObject)
            .then((res) => {
            var _a, _b, _c;
            if (res) {
                let countryList = [];
                let productList = [];
                let serviceList = [];
                if (((_a = res.lstCountrys) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    countryList = res.lstCountrys
                        .map((_) => { var _a; return (_a = _.intId) === null || _a === void 0 ? void 0 : _a.toString(); })
                        .filter((id) => id !== undefined);
                }
                if (((_b = res.lstProdSubSegment) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                    productList = res.lstProdSubSegment
                        .map((_) => { var _a; return (_a = _.intId) === null || _a === void 0 ? void 0 : _a.toString(); })
                        .filter((id) => id !== undefined);
                }
                if (((_c = res.lstServices) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                    serviceList = res.lstServices
                        .map((_) => _.intId)
                        .filter((id) => id !== undefined);
                }
                // Resolve the promise with the arrays
                resolve([countryList, productList, serviceList]);
            }
            else {
                reject(new Error("Response was empty or malformed"));
            }
        });
    });
};
